import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=8f1ca370&scoped=true&"
import script from "./Broadcast.vue?vue&type=script&lang=js&"
export * from "./Broadcast.vue?vue&type=script&lang=js&"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=8f1ca370&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1ca370",
  null
  
)

component.options.__file = "Broadcast.vue"
export default component.exports